(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".variant-picker__option-values:has(a.color-swatch)");
  const target = container?.querySelector(".is-selected");
  
  const pos = target.offsetLeft - (container.offsetWidth / 2) + (target.offsetWidth / 2);
  container.scrollTo({ left: pos, behavior: 'smooth' });
});

  (() => {
    const productSection = document.querySelector('.shopify-section--main-product');

    if (!productSection || productSection.dataset.styleBadgeSyncInitialized === 'true') return;

    productSection.dataset.styleBadgeSyncInitialized = 'true';

    const syncStyleBadges = () => {
      productSection.querySelectorAll('.product-info__title').forEach((title) => {
        const titleText = title.textContent;
        let style = '';

        if (titleText.includes('[P]')) {
          style = 'Pure';
        } else if (titleText.includes('[S]')) {
          style = 'Statement';
        }

        if (!style) return;

        const expectedBadge = `[ ${style} ]`;

        title.querySelectorAll('.product-info__title-style').forEach((badge) => {
          if (badge.textContent.trim() !== expectedBadge) {
            badge.textContent = expectedBadge;
          }
        });
      });
    };

    let syncScheduled = false;
    const scheduleStyleBadgeSync = () => {
      if (syncScheduled) return;

      syncScheduled = true;
      requestAnimationFrame(() => {
        syncScheduled = false;
        syncStyleBadges();
      });
    };

    new MutationObserver(scheduleStyleBadgeSync).observe(productSection, {
      childList: true,
      subtree: true,
    });

    window.addEventListener('pageshow', scheduleStyleBadgeSync);
    syncStyleBadges();
  })();

  } catch(e) { console.error(e); }
})();
})();
